import '../../utils/index.mjs';
import Text from './src/text2.mjs';
export { textProps } from './src/text.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElText = withInstall(Text);

export { ElText, ElText as default };
//# sourceMappingURL=index.mjs.map
